(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-buy"]) return;
  try {
    
  // Variant choice reloads the real product URL (?variant=), so price,
  // media and availability always come from Shopify's server render.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.location.replace(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
